import React from 'react'

import { Typography } from '@material-ui/core'
import { useTranslate } from 'react-admin'

export const InvoiceCreationResultStep = ({ classes, invoiceCount }) => {
  const translate = useTranslate()
  return (
    <>
      <div className={classes.resultDescription}>
        {invoiceCount !== 1
          ? translate(
              'resources.invoices.actions.create.response.descriptionPlural',
              {
                params: {
                  invoiceCount,
                },
              }
            )
          : translate(
              'resources.invoices.actions.create.response.descriptionSingular'
            )}
      </div>
      <Typography className={classes.sign}>
        {translate('resources.invoices.actions.create.response.sign')}
      </Typography>
    </>
  )
}
